// utils/notify.js

export function requestNotificationPermission() {
  if ('Notification' in window && Notification.permission === 'default') {
    Notification.requestPermission()
  }
}

export function showNotification(title, body, url) {
  if (!('Notification' in window)) {
    console.warn('不支持 Notification API')
    return
  }
  console.log('当前权限:', Notification.permission)
  if (Notification.permission === 'granted') {
    setTimeout(() => {
      const notification = new Notification(title, {
        body,
        icon: '/notify.png'
      })
      notification.onclick = () => {
        window.focus()
        if (url) window.open(url, '_blank')
      }
      setTimeout(() => notification.close(), 10000)
    }, 200)
  } else if (Notification.permission === 'default') {
    Notification.requestPermission()
  } else {
    console.warn('通知已被拒绝，请在浏览器设置中开启')
  }
}

